'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleBoxStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  expanded: _propTypes2.default.bool
};

var defaultProps = {
  expanded: false
};

var ALIGN_MAP = {
  top: 'flex-start',
  end: 'flex-end',
  bottom: 'center',
  stretch: 'stretch'
};

var style = function style(_ref) {
  var expanded = _ref.expanded,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var pathKey = expanded ? 'expanded' : 'collapsed';
  var path = theme.reactackle.components.accordion.item.title[pathKey];

  return '\n    background-color: ' + path.backgroundColor + ';\n    opacity: ' + path.opacity + ';\n    \n    &:hover {    \n      background-color: ' + path.hover.backgroundColor + ';\n      opacity: ' + path.hover.opacity + ';\n    }\n    \n    &:focus {    \n      background-color: ' + path.focus.backgroundColor + ';\n      opacity: ' + path.focus.opacity + ';\n    }\n  ';
};

var size = function size(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.accordion.item.title,
      align = _theme$reactackle$com.align,
      minHeight = _theme$reactackle$com.minHeight;


  return (0, _styledComponents.css)(['align-items:', ';', ''], ALIGN_MAP[align], minHeight && 'min-height: ' + (0, _reactackleCore.getValueString)(minHeight) + ';');
};

var expanded = function expanded(_ref3) {
  var themeFromProvider = _ref3.theme,
      expanded = _ref3.expanded;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var styleKey = expanded ? 'expanded' : 'collapsed';

  var color = theme.reactackle.components.accordion.item.title[styleKey].color;


  return (0, _styledComponents.css)(['color:', ';'], color);
};

var TitleBoxStyled = exports.TitleBoxStyled = _styledComponents2.default.button.withConfig({
  displayName: 'TitleBoxStyled'
})(['width:100%;display:flex;cursor:pointer;text-align:left;', ' &,&:hover,&:focus{outline:none;box-shadow:none;background-color:transparent;border:0 solid transparent;padding:0;}', ' ', ' ', ''], (0, _reactackleCore.transition)('background-color, opacity'), style, size, expanded);

TitleBoxStyled.propTypes = propTypes;
TitleBoxStyled.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-accordion/dist/AccordionItem/styles/TitleBoxStyled.js
// module id = 507
// module chunks = 0